import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import FacilityForm from './components/FacilityForm';
import RatingPage from './components/RatingPage';
import FacilityFormV2 from './components/FacilityForm_v2';
import RegisterForm from './components/RegisterComponents/RegisterForm';
import CompleteProfileForm from './components/RegisterComponents/CompleteProfileForm';
import ShowFacility from './components/ShowFacility';
import ShowDashboard from './components/Dashboard';
import Alerts from './components/Alerts';
import Team from './components/Team';
import ConciergerieGuide from './components/ConciergerieGuide';
import StaffPortal from './components/StaffPortal';
import HomePage from './components/HomePage';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import DataDeletion from './components/legal/DataDeletion';
import TermsOfSale from './components/legal/TermsOfSale';
import AppTerms from './components/legal/AppTerms';
import LegalNotice from './components/legal/LegalNotice';
import MapStatPage from "./components/StatsMap"
import MainBoardPage from "./components/MainBoard"
import CommercialDashboard from "./components/CommercialDashboard"
import AgentDetail from "./components/AgentDetail"
import FacilityDetail from "./components/FacilityDetail"
import CommercialGuide from "./components/CommercialGuide"
import CommercialLeads from "./components/CommercialLeads"
import CommercialAgents from "./components/CommercialAgents"
import AmbassadorTerritories from './components/commercial/AmbassadorTerritories';
import AmbassadorProspects from './components/commercial/AmbassadorProspects';
import AmbassadorVisitReview from './components/commercial/AmbassadorVisitReview';
import AmbassadorSettings from './components/commercial/AmbassadorSettings';
import AmbassadorApp from './components/ambassador/AmbassadorApp';
import AmbassadorHome from './components/ambassador/AmbassadorHome';
import AmbassadorMap from './components/ambassador/AmbassadorMap';
import ProspectDetail from './components/ambassador/ProspectDetail';
import ProspectNew from './components/ambassador/ProspectNew';
import KioskClaim from './components/kiosk/KioskClaim';
import FacilityTransferClaim from './components/facilityTransfer/FacilityTransferClaim';
import KioskPhotos from './components/kioskPhotos/KioskPhotos';
import AdminLists from './components/adminLists/AdminLists';
import AdminLandings from './components/adminLandings/AdminLandings';
import AdminAcquisition from './components/adminAcquisition/AdminAcquisition';
import './index.css';
import Statistic from './components/Statistic';
import MainMap from './components/MainMap'
import SignUp from "./components/SignUp"
import SharedListPage from './components/sharedLists/SharedListPage';
import ListsChartPage from './components/sharedLists/ListsChartPage';
import Documentation from './components/Documentation';



import PublicRatingBadge from './components/PublicRatingBadge';
import { captureReferralCode } from './utils/referral';
import { captureAttribution } from './utils/attribution';

// Runs once per page load, before the router even mounts, so a referral
// link is captured no matter which route it lands on (marketing link,
// /SignUp, /register/start, ...).
captureReferralCode();
captureAttribution();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Or use <HomePage /> if you want the real page */}
        <Route path="/ratings/:storeId" element={<RatingPage />} />
        <Route path="/v2/form/" element={<FacilityFormV2 />} />
        <Route path="/register/start" element={<RegisterForm />} />
        <Route path="/register/confirm" element={<CompleteProfileForm />} />
        <Route path="/ShowFacility/:id/:email" element={<ShowFacility />} />
        <Route path="/showDashboard" element={<ShowDashboard />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/alerts/guide" element={<ConciergerieGuide />} />
        <Route path="/team" element={<Team />} />
        <Route path="/staff" element={<StaffPortal />} />
        <Route path="/Statistic/:id" element={<Statistic />} />
        <Route path="/MapStats/:id" element={<MapStatPage />} />
        <Route path="/v1/form/" element={<FacilityForm />} />
        <Route path="/ManagerDashboard" element={<MainBoardPage />} />
        <Route path="/admin/commercial" element={<CommercialDashboard />} />
        <Route path="/admin/commercial/docs" element={<CommercialGuide />} />
        <Route path="/admin/commercial/leads" element={<CommercialLeads />} />
        <Route path="/admin/commercial/agents" element={<CommercialAgents />} />
        <Route path="/admin/commercial/ambassador/territories" element={<AmbassadorTerritories />} />
        <Route path="/admin/commercial/ambassador/prospects" element={<AmbassadorProspects />} />
        <Route path="/admin/commercial/ambassador/visits" element={<AmbassadorVisitReview />} />
        <Route path="/admin/commercial/ambassador/settings" element={<AmbassadorSettings />} />
        <Route path="/kiosk/claim/:code" element={<KioskClaim />} />
        <Route path="/facility-transfer/:token" element={<FacilityTransferClaim />} />
        <Route path="/admin/kiosk-photos" element={<KioskPhotos />} />
        <Route path="/admin/lists" element={<AdminLists />} />
        <Route path="/admin/landings" element={<AdminLandings />} />
        <Route path="/admin/acquisition" element={<AdminAcquisition />} />
        <Route path="/ambassador" element={<AmbassadorApp />}>
          <Route index element={<AmbassadorHome />} />
          <Route path="map" element={<AmbassadorMap />} />
          <Route path="prospects/:id" element={<ProspectDetail />} />
          <Route path="new" element={<ProspectNew />} />
        </Route>
        <Route path="/admin/commercial/agent/:id" element={<AgentDetail />} />
        <Route path="/admin/commercial/facility/:id" element={<FacilityDetail />} />
        <Route path="/MainMap" element={<MainMap />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/listes" element={<ListsChartPage />} />
        <Route path="/l/:code" element={<SharedListPage />} />
        <Route path="/OwnerLists" element={<Navigate to="/listes" replace />} />
        <Route path="/public/rating/:facilityId" element={<PublicRatingBadge />} />
        <Route path="/UserGuide" element={<Documentation />} />
        <Route path="/confidentialite" element={<PrivacyPolicy />} />
        <Route path="/suppression-donnees" element={<DataDeletion />} />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/conditions-generales" element={<TermsOfSale />} />
        <Route path="/conditions-utilisation" element={<AppTerms />} />
      </Routes>
    </Router>
  </React.StrictMode>
);
